<!-- Issue List Content -->
<div>

  <nx-pageTitle-box
    *ngIf="showPageTitle()"
    [label]="'Vorgänge'"
    [icon]="'icon-protocol-2'"
    [iconToolTip]="'Vorgänge'">
    <ng-template nxTemplate="end">
      <div class="mr-2 justify-end">
        <input
            #globalSearch
            pInputText
            type="text"
            class="p-inputtext p-component p-element w-[300px]"
            placeholder="Vorgang suchen" />
      </div>
      <nx-command-button
        *ngIf="rolesService.hasRole('framework_issue_create')"
        #taskListComp
        [reloadable]="reloadable"
        [style]="'light'"
        [commandName]="'issueCreateCommand'"
        [icon]="'icon-plus'">
      </nx-command-button>
    </ng-template>
  </nx-pageTitle-box>

  @if (showTabs()) {
    <ng-template #tabBadge let-index="index" let-label="label">
      <span>{{ label }}</span>
      @if (selectedFilter() === index) {
        <nx-count-badge [count]="totalElements()" />
      }
    </ng-template>

    <div class="flex flex-row">
      <div class="w-full">
        <p-tabView #tabView [activeIndex]="selectedFilter()" (activeIndexChange)="onFilterChange({index: $event})">
          <p-tabPanel>
            <ng-template pTemplate="header">
              <ng-container *ngTemplateOutlet="tabBadge; context: { index: 0, label: 'Offen' }"></ng-container>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <ng-container *ngTemplateOutlet="tabBadge; context: { index: 1, label: 'Abgeschlossen' }"></ng-container>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <ng-container *ngTemplateOutlet="tabBadge; context: { index: 2, label: 'Alle' }"></ng-container>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  }

  <div class="flex flex-col lg:flex-row px-[0.75rem] py-[0.4rem] leading-[1rem] bg-white gap-2" [class.border-t]="!showTabs()">
    <div class="flex flex-row flex-wrap gap-2 lg:flex-1">

      <!-- Filter: Issue Type -->
      <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [ngModel]="issueTypesModel()"
        (ngModelChange)="onIssueTypesChange($event)"
        (onClear)="onIssueTypesChange([])"
        [options]="issueTypesOptions()"
        [showClear]="true"
        [placeholder]="'Typ'"
        [dataKey]="'code'"
        [optionValue]="'code'"
        optionLabel="name">
      </nx-filter-multiSelect>

      <!-- Filter: Issue Status -->
      <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [ngModel]="issueStatusesModel()"
        (ngModelChange)="onIssueStatusesChange($event)"
        (onClear)="onIssueStatusesChange([])"
        [options]="issueStatusOptions()"
        [showClear]="true"
        [placeholder]="'Status'"
        [dataKey]="'code'"
        [optionValue]="'code'"
        optionLabel="label">
      </nx-filter-multiSelect>

      <!-- Filter: Assignee -->
      <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [ngModel]="assigneesModel()"
        (ngModelChange)="onAssigneesChange($event)"
        (onClear)="onAssigneesChange([])"
        [options]="assigneesOptions()"
        [showClear]="true"
        [placeholder]="'Zuweisung'"
        [dataKey]="'id'"
        [optionValue]="'id'"
        optionLabel="displayName">
        <ng-template pTemplate="selectedItems" let-assignees>
          @if (assignees?.length > 1) {
            Zuweisung: <span class="ml-1">{{ assignees.length }} ausgewählt</span>
          } @else {
            @for (assignee of assignees; track assignee.id; let isFirst = $first) {
              Zuweisung: {{ assignee.displayName }}
            }
            @empty {
              Zuweisung
            }
          }
        </ng-template>
      </nx-filter-multiSelect>

      <!-- Filter: Location -->
      <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [ngModel]="locationsModel()"
        (ngModelChange)="onLocationsChange($event)"
        (onClear)="onLocationsChange([])"
        [options]="locationsOptions()"
        [showClear]="true"
        [placeholder]="'Niederlassung'"
        [dataKey]="'id'"
        [optionValue]="'id'"
        optionLabel="name">
        <ng-template pTemplate="selectedItems" let-locations>
          @if (locations?.length > 1) {
            Niederlassung: <span class="ml-1">{{ locations.length }} ausgewählt</span>
          } @else {
            @for (location of locations; track location.id; let isFirst = $first) {
              Niederlassung: {{ location.name }}
            }
            @empty {
              Niederlassung
            }
          }
        </ng-template>
      </nx-filter-multiSelect>

      <!-- Filter: Due Date -->
      <nx-filter-date-select
        [className]="'table-filter'"
        placeholder="Fällig"
        [showIncludeOverDue]="true"
        [includeOverDueLabel]="'inkl. überfällige'"
        [ngModel]="dueDateModel()"
        (ngModelChange)="onDueDateChange($event)"
        (onClear)="onDueDateChange(null)"
        (onChange)="onDueDateChange($any($event))"
        optionLabel="label">
      </nx-filter-date-select>

      <!-- Filter: Labels -->
      <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [ngModel]="labelsModel()"
        (ngModelChange)="onLabelsChange($event)"
        (onClear)="onLabelsChange([])"
        [options]="labelsOptions()"
        [showClear]="true"
        [placeholder]="'Labels'"
        [dataKey]="'id'"
        [optionValue]="'id'"
        optionLabel="name">
        <ng-template pTemplate="item" let-label>
          <app-label [label]="label"></app-label>
        </ng-template>
        <ng-template pTemplate="selectedItems" let-labels>
          @if (labels?.length > 1) {
            <span class="ml-1">{{ labels.length }} ausgewählt</span>
          } @else {
            @for (label of labels; track label.id; let isFirst = $first) {
              <app-label [label]="label" [class]="isFirst ? 'ml-1 mr-1' : 'mr-1'"></app-label>
            }
            @empty {
              Labels
            }
          }
        </ng-template>
      </nx-filter-multiSelect>
    </div>
    <div class="flex flex-row justify-start lg:justify-end">
      <nx-sort-select
        placeholder="Sortierung"
        [appendTo]="'body'"
        [showNoSortOption]="true"
        [ngModel]="sortModel()"
        (ngModelChange)="onSortChange($event)"
        [options]="sortFields">
      </nx-sort-select>
    </div>
  </div>
  <div>
    <div>
    @for (issue of issues(); track issue.id; let isLast = $last) {
      <app-issue-row
        [isLast]="isLast"
        [issue]="issue"
        [hideLastBorder]="isLast"
        [showBinaryStatus]="selectedFilter() === 2">
      </app-issue-row>
    }
    <nx-empty-box
      class="border-t"
      *ngIf="issues().length === 0"
      [label]="'Keine Vorgänge gefunden'">
    </nx-empty-box>
    </div>
    <nx-simple-paginator
      [currentPage]="pageNumber()"
      [pageSize]="pageSize()"
      [totalElements]="totalElements()"
      [pageSizeOptions]="[15, 30, 50]"
      (pageChange)="onPageChange($any($event))"
      (pageSizeChange)="onPageSizeChange($any($event))">
    </nx-simple-paginator>
  </div>

</div>




